import { safeToString } from '@lighthouse/tools'

import type { SendMsgDingTalkRobotConfig } from '../../../types/flow'
import type { ActiveDingTalkRobotActionPayload } from '../../../types/node'
import type { ExtraParams } from './common'
import { generateVariableValue } from './common'

export const getDingTalkRobotVariableValue = (
    config: SendMsgDingTalkRobotConfig,
    extraParams: ExtraParams
): ActiveDingTalkRobotActionPayload['config'] => {
    const { msgtype, at, text, link, markdown, id, webhook, secret } = config
    const resolvedAt = generateVariableValue({ innerType: 'TEXT', jsonContent: at.atContent, extraParams })
    const atMobiles = typeof resolvedAt === 'string' ? resolvedAt.split(',') : []
    switch (msgtype) {
        case 'link': {
            const linkTitleValue = link
                ? generateVariableValue({
                      innerType: 'TEXT',
                      jsonContent: link.editorTitle,
                      extraParams,
                      options: { format: true, useFileUrl: true }
                  })
                : ''
            const linkTextValue = link
                ? generateVariableValue({
                      innerType: 'TEXT',
                      jsonContent: link.editorText,
                      extraParams,
                      options: { format: true, useFileUrl: true }
                  })
                : ''
            const picUrlValue = link
                ? generateVariableValue({
                      innerType: 'TEXT',
                      jsonContent: link.picUrl,
                      extraParams,
                      options: { format: true, useFileUrl: true }
                  })
                : ''
            const linkMessageValue = link
                ? generateVariableValue({
                      innerType: 'TEXT',
                      jsonContent: link?.editorMessageUrl,
                      extraParams,
                      options: { format: true, useFileUrl: true }
                  })
                : ''
            const linkValue = {
                title: safeToString(linkTitleValue),
                text: safeToString(linkTextValue),
                picUrl: safeToString(picUrlValue),
                messageUrl: safeToString(linkMessageValue)
            }

            return {
                id,
                msgtype,
                webhook,
                secret,
                at: { atMobiles },
                link: linkValue
            }
        }
        case 'markdown': {
            const markdownTextValue = markdown
                ? generateVariableValue({ innerType: 'TEXT', jsonContent: markdown.editorText, extraParams })
                : ''
            return {
                id,
                msgtype,
                webhook,
                secret,
                text: { content: safeToString(markdownTextValue) }
            }
        }

        default: {
            const textContentValue = text ? generateVariableValue({ innerType: 'TEXT', jsonContent: text.editorContent, extraParams }) : ''
            return {
                id,
                msgtype,
                webhook,
                secret,
                text: { content: safeToString(textContentValue) },
                at: { atMobiles }
            }
        }
    }
}
